import { render, staticRenderFns } from "./ButtonVideo.vue?vue&type=template&id=0f9380d6"
import script from "./ButtonVideo.vue?vue&type=script&lang=js"
export * from "./ButtonVideo.vue?vue&type=script&lang=js"
import style0 from "./ButtonVideo.vue?vue&type=style&index=0&id=0f9380d6&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports